export default __webpack_public_path__ + "static/media/Jyotirlinga.4d7b2e7b.jpg";